<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-10-14 15:58:03
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-10-16 14:21:01
 * @FilePath: /goldenSalesMobile/src/views/UsersAccountCenter/index.vue
 * @Description: 消费者个人中心
-->
<template>
  <div class='page-container'>
    <van-form class="login-form" @submit="onSubmit" :show-error="false">
      <div class="phone-input">
        <van-field
                v-model="phone"
                type="tel"
                name="phone"
                label="手机号"
                placeholder="点击输入"
                :rules="[{ pattern, message: '请输入有效的手机号' }]"
        />

        <verify-code :phone="phone" @onGetSmsCode="onGetSmsCode" />
      </div>
      <van-field
              v-model="authCode"
              type="number"
              name="authCode"
              label="验证码"
              placeholder="点击输入"
              maxlength="6"
              :rules="[{ required: true, message: '请输入验证码' }]"
      />
      <van-button
              round
              block
              color="linear-gradient(to right, #FA9B00, #FBCA39)"
              native-type="submit"
      >
        提交
      </van-button>
    </van-form>
  </div>
</template>

<script>
import VerifyCode from '@/components/VerifyCode/index'
import { putChangePhone,getMsCode } from '@/api/user'
import { setToken } from '@/utils/auth'
import { mobileReg } from '@/utils/index'

export default {
  components: { VerifyCode },
  data() {
    return {
      phone: '',
      authCode: '',
      pattern: mobileReg
    }
  },

  created() {
    this.init()
  },

  methods: {
    // 获取消费者信息
    init() {
      // getConsumerInfo()
      //   .then(res => {
      //     this.headImageUrl = res.HeadImageUrl;
      //     this.username = res.UserName;
      //     this.birthday = res.Birthday;
      //     this.sex = res.Sex;
      //     this.phone = res.Phone;
      //   })
    },

    onGetSmsCode() {
      getMsCode({phone: this.phone})
        .then(res => {
          if (res.success) {
            this.$toast('验证码已发送，请注意查收')
          } else {
            this.$toast(res.error)
          }
        })
        .catch(err => {
// console.log(err)
        })
    },

    onSubmit() {
      putChangePhone({ Phone: this.phone, SmsCode: this.authCode})
        .then(res => {
          if (res.UserId && res.Token) {
            sessionStorage.setItem('userPhone', this.phone);
            setToken(res.Token);
            localStorage.setItem('consumerId', res.UserId);
            this.$router.push({
              name: 'UsersAccountCenter'
            });
          }
        })
        .catch(err => {
// console.log(err)
        })
    }
  }
}
</script>

<style lang='scss' scoped>
  .page-container {
    box-sizing: border-box;
    padding: 0 60px;
    background: $blockBgColor;
    overflow: hidden;

    .logo-box {
      width: 360px;
      height: 76px;
      margin: 118px auto 234px;

      >img {
        width: 100%;
        height: 100%;
      }
    }

    .login-form {
      .phone-input {
        position: relative;

        >.getAuthCode-btn {
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -22px;
          z-index: 0;
          height:44px;
          font-size:32px;
          font-weight:500;
          color: rgba(251,202,57,1);
          line-height:44px;
          border: none;
        }
      }

      &::v-deep .van-cell {
        margin-top: 30px;
      }

      &::v-deep .van-button {
        font-size: 18px;
        font-weight: 600;
        margin-top: 80px;
        box-shadow:0px 4px 20px 0px rgba(255,200,99,1);
      }
    }
  }
</style>

